import React, {Dispatch, Fragment, useEffect, useState} from 'react';
import {Button, FormGroup, Label, Input} from 'reactstrap';
import {Modal, Typography, Box, IconButton} from '@mui/material';
import {LandingSiteFormContent} from '@integraciones_doc24/wehealthy-api/types/landing';
import {formAction} from '../../api/formLanding';
import {connect} from 'react-redux';
import {LandingSiteConfig} from '@integraciones_doc24/wehealthy-api/types/landing';
import {
  setStepVisible,
  setDinamikLink,
  setFormValues,
} from '../../reducer/config-reducer';
import {isBrowser} from 'react-device-detect';
import BackStepButton from './backStepButton';
import {Message} from '@integraciones_doc24/custom-message';
import CloseIcon from '@mui/icons-material/Close';

interface configObject {
  configReducer: {
    [x: string]: any;
    planSeleccionado: string;
    landingConfig: LandingSiteConfig;
  };
}
interface propiedades {
  content: LandingSiteFormContent;
  planSeleccionado: string;
  brandId: string;
  landingId: string;
  setStepVisible: Dispatch<string>;
  setDinamikLink: Dispatch<string>;
  setFormValues: (values: {[k: string]: {name: string; value: string}}) => void;
  useAppWeb: boolean;
}

interface LooseObject {
  [key: string]: any;
}

interface campo {
  id: string;
  type: string;
  max?: number;
  min?: number;
  regExp?: string;
}

const Form = (props: propiedades) => {
  const {content} = props;
  const [valoresCampos, setValoresCampos] = useState<string[]>(
    Array(content.form.fields.length).fill(''),
  );
  const [erroresCampos, setErroresCampos] = useState<string[]>(
    Array(content.form.fields.length).fill(''),
  );
  const [enviandoDatos, setEnviandoDatos] = useState(false);
  const [errorEnvio, setErrorEnvio] = useState(false);
  const [errorMessage, seterrorMessage] = useState<string | null>(null);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorDeCampos, seterrorDeCampos] = useState<string>('');

  useEffect(() => {
    const valores = [...valoresCampos];
    const valoresIniciales: {[k: string]: any} = {};

    content.form.fields.forEach((field, index) => {
      if (field.type === 'select') {
        valores[index] = field.options[0]['key'];
      }
      valoresIniciales[field.id] = valores[index] || '';
    });

    setValoresCampos(valores);
  }, [content.form.fields]);

  useEffect(() => {
    const updatedFormValues: {[k: string]: {name: string; value: string}} = {};

    content.form.fields.forEach((field, index) => {
      updatedFormValues[field.id] = {
        name: field.id,
        value: valoresCampos[index],
      };
    });

    props.setFormValues(updatedFormValues);
  }, [valoresCampos]);

  const manejarEventos = (index: number, value: string) => {
    const values = [...valoresCampos];
    values[index] = value;
    setValoresCampos(values);
  };

  const submitButton = () => {
    const valoresVacios = valoresCampos.some((val) => val === '');
    if (valoresVacios) {
      seterrorDeCampos(content.errorMessages?.mandatoryFields || 'Por favor, completa todos los campos.');
      setOpenErrorModal(true);
      return;
    }
    const hayErrores = erroresCampos.some((err) => err !== '');
    if (hayErrores) {
      seterrorDeCampos(content.errorMessages?.fixAllErrors || 'Por favor, corrige los errores en el formulario.');
      setOpenErrorModal(true);
      return;
    }


    setEnviandoDatos(true);
    setErrorEnvio(false);
    seterrorMessage(null);
    let query: {[k: string]: any} = {};
    content.form.fields.forEach((field, index) => {
      query[field.id] = valoresCampos[index];
    });
    let sendEmail = false;
    if (isBrowser) {
      sendEmail = true;
    }
    setTimeout(() => {
      formAction(
        query,
        props.landingId,
        props.brandId,
        props.planSeleccionado,
        sendEmail,
      )
        .then((res) => {
          setEnviandoDatos(false);
          if (isBrowser) {
            if (props.useAppWeb) {
              console.log('RES', res);
              props.setStepVisible('checkEmail');
              //window.location.replace(res);
            } else {
              props.setStepVisible('checkEmail');
              //props.setStepVisible('thanks');
              props.setDinamikLink(res);
            }
          } else {
            props.setStepVisible('checkEmail');
            //window.location.href = res;
          }
        })
        .catch((err) => {
          if (err.name === 'Conflict' && err.details.field === 'email') {
            seterrorMessage(content.errorMessages?.emailOnUse || 'El correo electrónico ya está en uso.');
          }
          setErrorEnvio(true);
          setEnviandoDatos(false);
        });
    }, 2000);
  };

  const esFechaValida = (valor: string): boolean => {
    const regexFecha =
      /^(19\d{2}|20\d{2})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    if (!regexFecha.test(valor)) return false;

    const [anioStr, mesStr, diaStr] = valor.split('-');
    const anio = parseInt(anioStr, 10);
    const mes = parseInt(mesStr, 10);
    const dia = parseInt(diaStr, 10);

    const anioActual = new Date().getFullYear();
    if (anio < 1900 || anio > anioActual) return false;

    const fecha = new Date(anio, mes - 1, dia);

    if (
      fecha.getFullYear() !== anio ||
      fecha.getMonth() + 1 !== mes ||
      fecha.getDate() !== dia
    ) {
      return false;
    }

    const hoy = new Date();
    if (fecha >= hoy) return false;

    return true;
  };

  const validarCampo = (campo: campo, index: number) => {
    const errores = [...erroresCampos];
    const valor = valoresCampos[index];

    if (campo.id === 'email') {
      if (!/^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(valor)) {
        errores[index] = content.errorMessages?.notValidEmail || 'El correo electrónico no es válido';
      } else {
        errores[index] = '';
      }
    }

    if (campo.type === 'text' && campo.max && campo.min) {
      if (valor.length < campo.min) {
        errores[index] = `Debe tener al menos ${campo.min} caracteres`;
      } else if (valor.length > campo.max) {
        errores[index] = `No debe superar ${campo.max} caracteres`;
      } else {
        errores[index] = '';
      }
    }

    if (campo.id === 'birthday') {
      if (!esFechaValida(valor)) {
        errores[index] = content.errorMessages?.notValidDate || 'La fecha no es válida';
      } else {
        errores[index] = '';
      }
    }

    if (campo.regExp) {
      let pattern = campo.regExp;
      if (!pattern.startsWith('^')) {
        pattern = `^[${pattern}]+$`;
      }

      const regex = new RegExp(pattern);

      if (!regex.test(valor)) {
        errores[index] = content.errorMessages?.notValidFormat || 'El formato no es válido';
      } else {
        errores[index] = '';
      }
    }

    setErroresCampos(errores);
  };

  return (
    <Fragment>
      <Box display="flex" flexWrap="wrap" id="form">
        <Box
          width={{xs: '100%', md: '58.3333%'}}
          display="flex"
          flexDirection="column"
        >
          <Box display="flex" flexWrap="wrap" className="color-base mt-3">
            <Box flex="1">
              <h1>{content.title}</h1>
              <h3>{content.subTitle}</h3>
            </Box>
          </Box>
          <Box
            display="flex"
            flexWrap="wrap"
            className="background-primary p-4 mt-3 mb-3 card border-0"
          >
            <Box flex="1">
              {content.form.fields.map((field, index) => {
                const inputProps: LooseObject = {
                  type: field.type,
                  name: field.id,
                  id: field.id,
                  value: valoresCampos[index],
                };
                if (field.type === 'text' && field.max && field.min) {
                  inputProps.max = field.max;
                  inputProps.min = field.min;
                }
                return (
                  <FormGroup key={index}>
                    <Label className="color-text" for={field.id}>
                      {field.label}
                    </Label>
                    {field.type === 'select' ? (
                      <Input
                        {...inputProps}
                        onChange={(event) =>
                          manejarEventos(index, event.target.value)
                        }
                        disabled={enviandoDatos}
                      >
                        {field.options.map((el) => {
                          return (
                            <option key={el.key} value={el.key}>
                              {el.label}
                            </option>
                          );
                        })}
                      </Input>
                    ) : (
                      <Input
                        {...inputProps}
                        onChange={(event) =>
                          manejarEventos(index, event.target.value)
                        }
                        disabled={enviandoDatos}
                        onBlur={() => {
                          validarCampo(field, index);
                        }}
                        className={
                          erroresCampos[index] !== '' ? 'is-invalid' : ''
                        }
                        autoCapitalize="off"
                      />
                    )}
                    {erroresCampos[index] !== '' && (
                      <div className="invalid-feedback">
                        {erroresCampos[index]}
                      </div>
                    )}
                  </FormGroup>
                );
              })}
            </Box>
          </Box>
          <Box display="flex" flexWrap="wrap" className="mb-5">
            <Box flex="1" className="text-end">
              {enviandoDatos && (
                <div className="lds-dual-ring sending-form after-border-text"></div>
              )}
              {content.form.backButton?.label ? (
                <BackStepButton label={content.form.backButton.label} />
              ) : null}
              {content.form.button && (
                <Button
                  className="background-primary ms-2 border-0 color-text form-button"
                  onClick={submitButton}
                  disabled={false}
                >
                  {!enviandoDatos && content.form.button.label}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <Modal
        open={openErrorModal}
        onClose={() => setOpenErrorModal(false)}
        aria-labelledby="error-modal-title"
        aria-describedby="error-modal-description"
      >
        <Box
          sx={{
            position: 'absolute' as 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            maxWidth: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: 'center',
            marginTop: '-100px',
          }}
        >
          <IconButton
            onClick={() => setOpenErrorModal(false)}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography id="error-modal-title" variant="h4" component="h2" textAlign={'start'} color='error'>
            Error
          </Typography>
          <Typography id="error-modal-description" sx={{mt: 2}} textAlign={'start'} marginBottom={4}>
            {errorDeCampos}
          </Typography>
        </Box>
      </Modal>
      {errorEnvio && (
        <Message
          modal={false}
          titulo="Error"
          message={errorMessage ?? 'ha ocurrido un error'}
          html={false}
          redirect=""
          cancelBt={false}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    planSeleccionado: state.configReducer.planSeleccionado,
    brandId: state.configReducer.landingConfig.brandId,
    landingId: state.configReducer.landingConfig.id,
    formValues: state.configReducer.formValues,
  };
};
export default connect(mapStateToProps, {
  setStepVisible,
  setDinamikLink,
  setFormValues,
})(Form);
